// ALL,TODAY,RUNNING,COMPLETED,TIMEOUT,UNASSIGNED
export const tabs = [
  {
    label: "全部",
    value: "ALL"
  },
  {
    label: "今日任务",
    value: "TODAY"
  },
  {
    label: "待认领",
    value: "UNASSIGNED"
  },
  {
    label: "待处理",
    value: "RUNNING"
  },
  {
    label: "待审核",
    value: "VERIFYING"
  },
  {
    label: "已完成",
    value: "COMPLETED"
  },
  {
    label: "已逾期",
    value: "TIMEOUT"
  }
]

export const todoListTabs = [
  {
    label: "未完成",
    value: "MY_RUNNING"
  },
  {
    label: "已完成",
    value: "MY_COMPLETED"
  },
  {
    label: "我创建的",
    value: "MY_CREATED"
  },
  {
    label: "我参与的",
    value: "MY_RELATED"
  },
  {
    label: "下属负责的",
    value: "SUBORDINATE"
  }
]

export const tableColumns = [
  {
    label: "任务标题",
    prop: "name",
    width: "320",
    contentAlign: "left"
  },
  {
    label: "任务路径",
    prop: "path",
    width: "150",
    contentAlign: "center"
  },
  {
    label: "状态",
    prop: "status",
    width: "100",
    contentAlign: "center"
  },
  {
    label: "负责人",
    prop: "assigneeUser",
    width: "100",
    contentAlign: "center"
  },
  {
    label: "负责角色",
    prop: "assigneeRole",
    width: "100",
    contentAlign: "center"
  },
  {
    label: "开始时间",
    prop: "startDate",
    width: "100",
    contentAlign: "center"
  },
  {
    label: "截止时间",
    prop: "dueDate",
    width: "100",
    contentAlign: "center"
  },
  {
    label: "优先级",
    prop: "priorityStr",
    width: "80",
    contentAlign: "center"
  },
  {
    label: "备注",
    prop: "description",
    width: "180",
    contentAlign: "center"
  }
]

export const sortKeys = [
  { title: "按创建时间", command: "createAt" },
  { title: "按开始时间", command: "startAt" },
  { title: "按截止时间", command: "dueDate" },
  { title: "按完成时间", command: "completeAt" }
]
